import { z } from 'zod';

export const sessionStateSchema = z.object({
  id: z.string().nullable(),
  data: z.any().nullable(),
  isCard: z.boolean().optional(),
  checkoutRef: z.string().optional(),
});

export type SessionState = z.infer<typeof sessionStateSchema>;
